import React from "react";
import "./AROBadge.css";

export type AROBadgeVariant = "green" | "amber" | "red" | "blue" | "gray";

interface AROBadgeProps {
  label:    string;
  variant?: AROBadgeVariant;
}

export default function AROBadge({ label, variant = "gray" }: AROBadgeProps) {
  return (
    <span className={`aro-badge aro-badge--${variant}`}>{label}</span>
  );
}
